"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//数据库里需要存两份图片地址，一张为原图地址，一张为裁剪后的头像地址
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var confirmPwd = function confirmPwd(rule, value, callback) {
      if (value !== _this.userInfo.password) {
        callback(new Error("两次密码输入不一致。"));
      } else {
        callback();
      }
    };
    return {
      userInfo: {
        avatarUrl: "",
        oldPassWord: "",
        password: "",
        isPwd: "",
        email: ""
      },
      userImg: require("@/assets/img/userHD.png"),
      userInfoForm: {
        username: "",
        department: "",
        tel: "",
        email: "",
        remark: ""
      },
      dialogVisible: false,
      options: {
        autoCrop: true,
        //默认生成截图框
        fixedBox: true,
        //固定截图框大小
        canMoveBox: false,
        //截图框不能拖动
        centerBox: false,
        //截图框被限制在图片里面
        autoCropWidth: 190,
        //截图框宽度
        autoCropHeight: 190 //截图框高度
      },
      previews: {},
      //实时预览图数据
      attach: {
        //后端附件表
        id: "",
        userId: "",
        customaryUrl: "",
        //原图片路径
        laterUrl: "",
        //裁剪后图片路径  /static/logo.png
        attachType: "photo" //附件类型
      },
      rules: {
        username: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }, {
          min: 3,
          max: 15,
          message: "长度在 3 到 15 个字符",
          trigger: "blur"
        }],
        department: [{
          required: true,
          message: "请输入单位名称",
          trigger: "blur"
        }, {
          min: 2,
          max: 60,
          message: "长度在 2 到 60 个字符",
          trigger: "blur"
        }],
        tel: [{
          required: true,
          message: "请输入联系方式",
          trigger: "blur"
        }, {
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: "请输入邮箱",
          trigger: "blur"
        }, {
          validator: _validate.validateEMail,
          trigger: "blur"
        }],
        remark: [{
          required: false,
          message: "备注推荐60字以内。",
          trigger: "blur"
        }, {
          min: 0,
          max: 60,
          message: "备注推荐60字以内。",
          trigger: "blur"
        }],
        oldPassWord: [{
          required: true,
          message: "请输入原始密码",
          trigger: "blur"
        }, {
          min: 6,
          max: 15,
          message: "长度在 6 到 15 个字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入新密码",
          trigger: "blur"
        }, {
          min: 6,
          max: 15,
          message: "长度在 6 到 15 个字符",
          trigger: "blur"
        }],
        isPwd: [{
          required: true,
          message: "请输入确认密码",
          trigger: "blur"
        }, {
          min: 6,
          max: 15,
          message: "长度在 6 到 15 个字符",
          trigger: "blur"
        }, {
          validator: confirmPwd,
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    //控制弹出层关闭
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    //实时预览
    realTime: function realTime(data) {
      this.previews = data;
    },
    //点击图片调取input
    clickUpload: function clickUpload() {
      this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
    },
    //选择本地图片
    uploadImg: function uploadImg(e, num) {
      var _this2 = this;
      console.log(num);
      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|png|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$message.error("图片类型必须是,jpeg,jpg,png中的一种");
        return false;
      }
      //fileReader 接口，用于异步读取文件数据
      var reader = new FileReader();
      reader.readAsDataURL(file); //重要 以dataURL形式读取文件
      reader.onload = function (e) {
        // data = window.URL.createObjectURL(new Blob([e.target.result])) 转化为blob格式
        var data = e.target.result;
        _this2.attach.customaryUrl = data;
        // 转化为base64
        reader.readAsDataURL(file);
        // 转化为blob
      };
    },
    //确认截图,上传
    confirm: function confirm(type) {
      this.$refs.cropper.getCropData(function (res) {
        console.log(res); //这里截图后的url 是base64格式 让后台转下就可以
      });
    },
    // 表单提交
    submitForm: function submitForm(val) {
      var _this3 = this;
      this.$refs[val].validate(function (valid) {
        if (valid) {
          var v = JSON.parse(JSON.stringify(_this3.userInfo));
          v.password = _this3.$md5(_this3.userInfo.password);
          v.oldPassWord = _this3.$md5(_this3.userInfo.oldPassWord);
          console.log('v', v);
          _this3.$store.dispatch("user/upDateUserInfo", v).then(function (res) {
            _this3.$message.success("修改成功。");
          });
        } else {
          _this3.$message.error("修改失败，请先检查填写信息");
        }
      });
    },
    resetForm: function resetForm(val) {
      this.$refs[val].resetFields();
    }
  }
};